/**
 * @fileoverview gRPC-Web generated client stub for legebill.site.activitytype.v4
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: legebill/site/activitytype/v4/activity_type.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb';
import * as legebill_site_activitytype_v4_activity_type_pb from '../../../../legebill/site/activitytype/v4/activity_type_pb';
import * as legebill_type_activity_type_pb from '../../../../legebill/type/activity_type_pb';


export class ActivityTypeServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorListActivityTypes = new grpcWeb.MethodDescriptor(
    '/legebill.site.activitytype.v4.ActivityTypeService/ListActivityTypes',
    grpcWeb.MethodType.UNARY,
    legebill_site_activitytype_v4_activity_type_pb.ListActivityTypesRequest,
    legebill_site_activitytype_v4_activity_type_pb.ListActivityTypesResponse,
    (request: legebill_site_activitytype_v4_activity_type_pb.ListActivityTypesRequest) => {
      return request.serializeBinary();
    },
    legebill_site_activitytype_v4_activity_type_pb.ListActivityTypesResponse.deserializeBinary
  );

  listActivityTypes(
    request: legebill_site_activitytype_v4_activity_type_pb.ListActivityTypesRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_activitytype_v4_activity_type_pb.ListActivityTypesResponse>;

  listActivityTypes(
    request: legebill_site_activitytype_v4_activity_type_pb.ListActivityTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_activitytype_v4_activity_type_pb.ListActivityTypesResponse) => void): grpcWeb.ClientReadableStream<legebill_site_activitytype_v4_activity_type_pb.ListActivityTypesResponse>;

  listActivityTypes(
    request: legebill_site_activitytype_v4_activity_type_pb.ListActivityTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_activitytype_v4_activity_type_pb.ListActivityTypesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.activitytype.v4.ActivityTypeService/ListActivityTypes',
        request,
        metadata || {},
        this.methodDescriptorListActivityTypes,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.activitytype.v4.ActivityTypeService/ListActivityTypes',
    request,
    metadata || {},
    this.methodDescriptorListActivityTypes);
  }

  methodDescriptorSearchActivityTypes = new grpcWeb.MethodDescriptor(
    '/legebill.site.activitytype.v4.ActivityTypeService/SearchActivityTypes',
    grpcWeb.MethodType.UNARY,
    legebill_site_activitytype_v4_activity_type_pb.SearchActivityTypesRequest,
    legebill_site_activitytype_v4_activity_type_pb.SearchActivityTypesResponse,
    (request: legebill_site_activitytype_v4_activity_type_pb.SearchActivityTypesRequest) => {
      return request.serializeBinary();
    },
    legebill_site_activitytype_v4_activity_type_pb.SearchActivityTypesResponse.deserializeBinary
  );

  searchActivityTypes(
    request: legebill_site_activitytype_v4_activity_type_pb.SearchActivityTypesRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_activitytype_v4_activity_type_pb.SearchActivityTypesResponse>;

  searchActivityTypes(
    request: legebill_site_activitytype_v4_activity_type_pb.SearchActivityTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_activitytype_v4_activity_type_pb.SearchActivityTypesResponse) => void): grpcWeb.ClientReadableStream<legebill_site_activitytype_v4_activity_type_pb.SearchActivityTypesResponse>;

  searchActivityTypes(
    request: legebill_site_activitytype_v4_activity_type_pb.SearchActivityTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_activitytype_v4_activity_type_pb.SearchActivityTypesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.activitytype.v4.ActivityTypeService/SearchActivityTypes',
        request,
        metadata || {},
        this.methodDescriptorSearchActivityTypes,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.activitytype.v4.ActivityTypeService/SearchActivityTypes',
    request,
    metadata || {},
    this.methodDescriptorSearchActivityTypes);
  }

  methodDescriptorListFavouriteActivityTypes = new grpcWeb.MethodDescriptor(
    '/legebill.site.activitytype.v4.ActivityTypeService/ListFavouriteActivityTypes',
    grpcWeb.MethodType.UNARY,
    legebill_site_activitytype_v4_activity_type_pb.ListFavouriteActivityTypesRequest,
    legebill_site_activitytype_v4_activity_type_pb.ListFavouriteActivityTypesResponse,
    (request: legebill_site_activitytype_v4_activity_type_pb.ListFavouriteActivityTypesRequest) => {
      return request.serializeBinary();
    },
    legebill_site_activitytype_v4_activity_type_pb.ListFavouriteActivityTypesResponse.deserializeBinary
  );

  listFavouriteActivityTypes(
    request: legebill_site_activitytype_v4_activity_type_pb.ListFavouriteActivityTypesRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_activitytype_v4_activity_type_pb.ListFavouriteActivityTypesResponse>;

  listFavouriteActivityTypes(
    request: legebill_site_activitytype_v4_activity_type_pb.ListFavouriteActivityTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_activitytype_v4_activity_type_pb.ListFavouriteActivityTypesResponse) => void): grpcWeb.ClientReadableStream<legebill_site_activitytype_v4_activity_type_pb.ListFavouriteActivityTypesResponse>;

  listFavouriteActivityTypes(
    request: legebill_site_activitytype_v4_activity_type_pb.ListFavouriteActivityTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_activitytype_v4_activity_type_pb.ListFavouriteActivityTypesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.activitytype.v4.ActivityTypeService/ListFavouriteActivityTypes',
        request,
        metadata || {},
        this.methodDescriptorListFavouriteActivityTypes,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.activitytype.v4.ActivityTypeService/ListFavouriteActivityTypes',
    request,
    metadata || {},
    this.methodDescriptorListFavouriteActivityTypes);
  }

  methodDescriptorCreateFavouriteActivityType = new grpcWeb.MethodDescriptor(
    '/legebill.site.activitytype.v4.ActivityTypeService/CreateFavouriteActivityType',
    grpcWeb.MethodType.UNARY,
    legebill_site_activitytype_v4_activity_type_pb.CreateFavouriteActivityTypeRequest,
    legebill_site_activitytype_v4_activity_type_pb.FavouriteActivityType,
    (request: legebill_site_activitytype_v4_activity_type_pb.CreateFavouriteActivityTypeRequest) => {
      return request.serializeBinary();
    },
    legebill_site_activitytype_v4_activity_type_pb.FavouriteActivityType.deserializeBinary
  );

  createFavouriteActivityType(
    request: legebill_site_activitytype_v4_activity_type_pb.CreateFavouriteActivityTypeRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_activitytype_v4_activity_type_pb.FavouriteActivityType>;

  createFavouriteActivityType(
    request: legebill_site_activitytype_v4_activity_type_pb.CreateFavouriteActivityTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_activitytype_v4_activity_type_pb.FavouriteActivityType) => void): grpcWeb.ClientReadableStream<legebill_site_activitytype_v4_activity_type_pb.FavouriteActivityType>;

  createFavouriteActivityType(
    request: legebill_site_activitytype_v4_activity_type_pb.CreateFavouriteActivityTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_activitytype_v4_activity_type_pb.FavouriteActivityType) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.activitytype.v4.ActivityTypeService/CreateFavouriteActivityType',
        request,
        metadata || {},
        this.methodDescriptorCreateFavouriteActivityType,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.activitytype.v4.ActivityTypeService/CreateFavouriteActivityType',
    request,
    metadata || {},
    this.methodDescriptorCreateFavouriteActivityType);
  }

  methodDescriptorReorderFavouriteActivityType = new grpcWeb.MethodDescriptor(
    '/legebill.site.activitytype.v4.ActivityTypeService/ReorderFavouriteActivityType',
    grpcWeb.MethodType.UNARY,
    legebill_site_activitytype_v4_activity_type_pb.ReorderFavouriteActivityTypeRequest,
    legebill_site_activitytype_v4_activity_type_pb.ReorderFavouriteActivityTypeResponse,
    (request: legebill_site_activitytype_v4_activity_type_pb.ReorderFavouriteActivityTypeRequest) => {
      return request.serializeBinary();
    },
    legebill_site_activitytype_v4_activity_type_pb.ReorderFavouriteActivityTypeResponse.deserializeBinary
  );

  reorderFavouriteActivityType(
    request: legebill_site_activitytype_v4_activity_type_pb.ReorderFavouriteActivityTypeRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_activitytype_v4_activity_type_pb.ReorderFavouriteActivityTypeResponse>;

  reorderFavouriteActivityType(
    request: legebill_site_activitytype_v4_activity_type_pb.ReorderFavouriteActivityTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_activitytype_v4_activity_type_pb.ReorderFavouriteActivityTypeResponse) => void): grpcWeb.ClientReadableStream<legebill_site_activitytype_v4_activity_type_pb.ReorderFavouriteActivityTypeResponse>;

  reorderFavouriteActivityType(
    request: legebill_site_activitytype_v4_activity_type_pb.ReorderFavouriteActivityTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_activitytype_v4_activity_type_pb.ReorderFavouriteActivityTypeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.activitytype.v4.ActivityTypeService/ReorderFavouriteActivityType',
        request,
        metadata || {},
        this.methodDescriptorReorderFavouriteActivityType,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.activitytype.v4.ActivityTypeService/ReorderFavouriteActivityType',
    request,
    metadata || {},
    this.methodDescriptorReorderFavouriteActivityType);
  }

  methodDescriptorDeleteFavouriteActivityType = new grpcWeb.MethodDescriptor(
    '/legebill.site.activitytype.v4.ActivityTypeService/DeleteFavouriteActivityType',
    grpcWeb.MethodType.UNARY,
    legebill_site_activitytype_v4_activity_type_pb.DeleteFavouriteActivityTypeRequest,
    google_protobuf_empty_pb.Empty,
    (request: legebill_site_activitytype_v4_activity_type_pb.DeleteFavouriteActivityTypeRequest) => {
      return request.serializeBinary();
    },
    google_protobuf_empty_pb.Empty.deserializeBinary
  );

  deleteFavouriteActivityType(
    request: legebill_site_activitytype_v4_activity_type_pb.DeleteFavouriteActivityTypeRequest,
    metadata: grpcWeb.Metadata | null): Promise<google_protobuf_empty_pb.Empty>;

  deleteFavouriteActivityType(
    request: legebill_site_activitytype_v4_activity_type_pb.DeleteFavouriteActivityTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void): grpcWeb.ClientReadableStream<google_protobuf_empty_pb.Empty>;

  deleteFavouriteActivityType(
    request: legebill_site_activitytype_v4_activity_type_pb.DeleteFavouriteActivityTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: google_protobuf_empty_pb.Empty) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.activitytype.v4.ActivityTypeService/DeleteFavouriteActivityType',
        request,
        metadata || {},
        this.methodDescriptorDeleteFavouriteActivityType,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.activitytype.v4.ActivityTypeService/DeleteFavouriteActivityType',
    request,
    metadata || {},
    this.methodDescriptorDeleteFavouriteActivityType);
  }

  methodDescriptorListRecentActivityTypes = new grpcWeb.MethodDescriptor(
    '/legebill.site.activitytype.v4.ActivityTypeService/ListRecentActivityTypes',
    grpcWeb.MethodType.UNARY,
    legebill_site_activitytype_v4_activity_type_pb.ListRecentActivityTypesRequest,
    legebill_site_activitytype_v4_activity_type_pb.ListRecentActivityTypesResponse,
    (request: legebill_site_activitytype_v4_activity_type_pb.ListRecentActivityTypesRequest) => {
      return request.serializeBinary();
    },
    legebill_site_activitytype_v4_activity_type_pb.ListRecentActivityTypesResponse.deserializeBinary
  );

  listRecentActivityTypes(
    request: legebill_site_activitytype_v4_activity_type_pb.ListRecentActivityTypesRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_site_activitytype_v4_activity_type_pb.ListRecentActivityTypesResponse>;

  listRecentActivityTypes(
    request: legebill_site_activitytype_v4_activity_type_pb.ListRecentActivityTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_site_activitytype_v4_activity_type_pb.ListRecentActivityTypesResponse) => void): grpcWeb.ClientReadableStream<legebill_site_activitytype_v4_activity_type_pb.ListRecentActivityTypesResponse>;

  listRecentActivityTypes(
    request: legebill_site_activitytype_v4_activity_type_pb.ListRecentActivityTypesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_site_activitytype_v4_activity_type_pb.ListRecentActivityTypesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.activitytype.v4.ActivityTypeService/ListRecentActivityTypes',
        request,
        metadata || {},
        this.methodDescriptorListRecentActivityTypes,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.activitytype.v4.ActivityTypeService/ListRecentActivityTypes',
    request,
    metadata || {},
    this.methodDescriptorListRecentActivityTypes);
  }

  methodDescriptorGetActivityType = new grpcWeb.MethodDescriptor(
    '/legebill.site.activitytype.v4.ActivityTypeService/GetActivityType',
    grpcWeb.MethodType.UNARY,
    legebill_site_activitytype_v4_activity_type_pb.GetActivityTypeRequest,
    legebill_type_activity_type_pb.ActivityType,
    (request: legebill_site_activitytype_v4_activity_type_pb.GetActivityTypeRequest) => {
      return request.serializeBinary();
    },
    legebill_type_activity_type_pb.ActivityType.deserializeBinary
  );

  getActivityType(
    request: legebill_site_activitytype_v4_activity_type_pb.GetActivityTypeRequest,
    metadata: grpcWeb.Metadata | null): Promise<legebill_type_activity_type_pb.ActivityType>;

  getActivityType(
    request: legebill_site_activitytype_v4_activity_type_pb.GetActivityTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: legebill_type_activity_type_pb.ActivityType) => void): grpcWeb.ClientReadableStream<legebill_type_activity_type_pb.ActivityType>;

  getActivityType(
    request: legebill_site_activitytype_v4_activity_type_pb.GetActivityTypeRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: legebill_type_activity_type_pb.ActivityType) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/legebill.site.activitytype.v4.ActivityTypeService/GetActivityType',
        request,
        metadata || {},
        this.methodDescriptorGetActivityType,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/legebill.site.activitytype.v4.ActivityTypeService/GetActivityType',
    request,
    metadata || {},
    this.methodDescriptorGetActivityType);
  }

}

